/** @format */

export const getModelOverviewGridTemplateColumns = ({
    hasImages,
    isLoadingImages,
    isSmallTablet,
}: {
    hasImages: boolean;
    isLoadingImages: boolean;
    isSmallTablet: boolean;
}) => {
    const showImageLayout = hasImages || isLoadingImages;

    if (!showImageLayout || isSmallTablet) {
        return '1fr';
    }

    return '1fr 1fr';
};
